<template>
  <div>
    <div class="location-tabs">
      <div
        @click="type !== 'check_in' ? $emit('back') : null"
        :class="{ 'segment-button-checked': type === 'check_in' }"
      >
        {{ $t("bookings.checkInLocation") }}
      </div>
      <div
        @click="type === 'check_in' ? $emit('continue') : null"
        :class="{ 'segment-button-checked': type !== 'check_in' }"
      >
        {{ $t("bookings.checkOutLocation") }}
      </div>
    </div>
    <ion-list v-if="items.length > 0">
      <ion-radio-group v-model="selectedItem">
        <template v-for="(item, index) of items" :key="item.id">
          <ion-item>
            <ion-label>
              {{ item.name }}
              <div>{{ item.address }}</div>
              <div v-if="item.price > 0" class="price">+{{ item.price }}€</div>
            </ion-label>
            <ion-radio slot="start" :value="item.id"> </ion-radio>
          </ion-item>
          <p
            v-if="index === 0 && type === 'check_in'"
            class="pickup-alert"
            v-html="$t('bookings.pickupSchedule')"
          ></p>
        </template>
      </ion-radio-group>
    </ion-list>
  </div>
</template>

<script>
import axios from "axios";
import { defineComponent } from "vue";
import {
  IonList,
  IonItem,
  IonLabel,
  IonRadioGroup,
  IonRadio,
} from "@ionic/vue";

export default defineComponent({
  components: {
    IonList,
    IonItem,
    IonLabel,
    IonRadioGroup,
    IonRadio,
  },
  props: {
    modelValue: {
      required: false,
      type: Array,
    },
    dates: {
      required: false,
      type: Object,
    },
    vehicleTypeId: {
      required: false,
      type: Number,
    },
    checkInLocationId: {
      required: false,
      type: Number,
    },
    type: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      items: [],
      selectedItem: null,
      currentSegment: this.type === "check_in" ? "start" : "end",
    };
  },
  watch: {
    selectedItem: {
      deep: false,
      handler(newVal) {
        this.$emit("update:modelValue", newVal);
      },
    },
    vehicleTypeId: {
      deep: false,
      handler(newVal) {
        this.selectedItem = null;
        this.getLocations();
      },
    },
    checkInLocationId: {
      deep: false,
      handler(newVal) {
        this.getLocations();
      },
    },
    dates: {
      deep: false,
      handler(newVal) {
        this.getLocations();
      },
    },
  },
  mounted() {
    this.currentSegment = this.type === "check_in" ? "start" : "end";
    this.getLocations();
  },
  methods: {
    getLocations() {
      if (this.dates === null || this.vehicleTypeId === null) return;
      axios.post("/bookings/pickup-locations", {
        dates: this.dates,
        vehicleTypeId: this.vehicleTypeId,
        checkInLocationId: this.checkInLocationId,
      }).then((resp) => {
        this.items = resp.data.filter((item) => {
          return item[this.type] === true;
        });
        const defaultItem = this.items.filter((item) => {
          return item.default === true;
        });
        if (defaultItem.length > 0) {
          this.selectedItem = defaultItem[0].id;
        } else {
          this.selectedItem = this.items[0].id;
        }
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.v-list-item__action {
  margin-right: 16px;
}
.v-avatar {
  margin: 0 14px 0 -16px;
}
.alert-non {
  background: #f7f7cf;
  color: #7a630e;
  font-weight: 500;
  padding: 20px;
  margin: 30px 16px;
  width: 95%;
  z-index: 1;
}
.price {
  color: #b04a24;
  position: absolute;
  right: 20px;
  top: 18px;
  font-size: 18px;
}
.location-tabs {
  display: flex;
  margin-top: 20px;
  > div {
    flex: 1;
    border-bottom: 3px solid transparent;
    padding: 12px;
    text-transform: uppercase;
    font-size: 15px;
    color: #100f0e;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
    &.segment-button-checked {
      border-bottom: 3px solid #0b5a85;
      background: #e2f4ff;
      color: #0b5a85;
    }
  }
}
.pickup-alert {
  margin: 16px;
  padding: 10px 16px;
  background: #d7f7ff;
  color: #164a5c;
  font-weight: 500;
}
</style>
